import { AuthContext as e } from "../context/AuthContext.mjs";
import { useContext as t } from "react";
//#region src/hooks/useAuth.ts
var n = () => {
	let n = t(e);
	if (!n) throw Error("useAuth must be used inside <AuthProvider>");
	return n;
}, r = () => {
	let { isAuthenticated: e } = n();
	return e;
};
//#endregion
export { n as useAuth, r as useIsAuthenticated };
